<template>
    <div>
        <div v-if="signedIn" class="card border-primary card-primary">
            <div class="card-body">
                <div class="form-group">
                    <label for="channel_id" class="font-weight-bold"
                        >{{ __("Choose Channels") }}:</label
                    >
                    <multiselect
                        v-model="channels_ids"
                        :options="channels"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Pick some"
                        label="name"
                        track-by="name"
                        :preselect-first="true"
                        id="channel_id"
                        required
                    >
                    </multiselect>

                    <span
                        v-if="errors.channel_ids"
                        v-text="errors.channel_ids ? errors.channel_ids[0] : ''"
                        class="red"
                    ></span>
                    <small v-else>{{
                        __("Ask your question to specific community")
                    }}</small>
                </div>
                <div class="form-group">
                    <label for="title" class="font-weight-bold"
                        >{{ __("Title") }} :</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        v-model="title"
                        id="title"
                        required
                        :placeholder="__('Title here..')"
                    />
                    <span
                        v-if="errors.title"
                        v-text="errors.title ? errors.title[0] : ''"
                        class="red"
                    ></span>
                    <small v-else>{{
                        __(
                            "Be specific and imagine you’re asking a question to another person"
                        )
                    }}</small>
                </div>
                <div class="form-group">
                    <label for="body" class="font-weight-bold"
                        >{{ __("Body") }} :</label
                    >
                    <wysiwyg
                        id="create-thread"
                        name="body"
                        v-model="body"
                        :value="body"
                        :placeholder="__('Explain here..')"
                        required
                    ></wysiwyg>
                    <span
                        v-if="errors.body"
                        v-text="errors.body ? errors.body[0] : ''"
                        class="red"
                    ></span>
                    <small v-else>{{
                        __(
                            "Include all the information someone would need to answer your question"
                        )
                    }}</small>
                </div>
                <input
                    type="hidden"
                    id="g-recaptcha"
                    name="recaptcha_response"
                    v-model="recaptcha_response"
                />

                <input
                    type="submit"
                    id="publish"
                    class="btn btn-primary"
                    @click="addThread"
                    :value="__('Publish')"
                    v-tooltip="__('Publish a Thread')"
                    :disabled="active"
                />
            </div>
        </div>
        <p class="text-center mt-4" v-else>
            {{ __("Please") }}
            <a href="/login">{{ __("Sign in") }}</a>
            {{ __("to ask questions.") }}
        </p>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    props: ["channels", "recaptcha_site_key"],
    components: { Multiselect },

    data() {
        return {
            channels_ids: [],
            title: "",
            body: "",
            active: false,
            recaptcha_response: "",
            errors: {},
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        addThread() {
            this.$Progress.start();
            this.active = true;

            axios
                .post("/threads", {
                    channel_ids: this.channels_ids.map((o) => o.id),
                    title: this.title,
                    body: this.body,
                    recaptcha_response: this.recaptcha_response,
                })
                .then(({ data }) => {
                    this.$Progress.finish();
                    window.location =
                        "/threads/" + data.channel.slug + "/" + data.slug;
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;

                    this.active = false;

                    this.load();
                    this.$Progress.fail();
                });
        },
        load() {
            let vm = this;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(vm.recaptcha_site_key, {
                        action: "homepage",
                    })
                    .then(function (response) {
                        vm.recaptcha_response = response;
                    });
            });
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>
